module.exports = __webpack_public_path__ + "img/img03.ebcf9f25.png";